///ts:ref=UserAgentParser
/// <reference path="./UserAgentParser.ts"/> ///ts:ref:generated
class Browser {
	private static MSIE:string = 'MSIE';
	private static Edge:string = 'Edge';
	private static Chrome:string = 'Chrome';
	private static Firefox:string = 'Firefox';
	private static Opera:string = 'Opera';
	private static Safari:string = 'Safari';
	private static YaBrowser:string = 'YaBrowser';
	private static FacebookCanvasDesktop:string = 'FacebookCanvasDesktop';

	private static _userAgent:string = null;
	public static getUserAgent():string {
		if (!Browser._userAgent) {
			Browser._userAgent = navigator.userAgent;
		}
		return Browser._userAgent;
	}

	private static _info:UserAgentParser.ParseResult = null;
	public static getInfo():UserAgentParser.ParseResult {
		if (!Browser._info) {
			let agent = Browser.getUserAgent();
			this._info =  UserAgentParser.parse(agent);
		}
		return Browser._info;
	}

	public static isIe():boolean {
		return Browser.getInfo().parentBrowser === Browser.MSIE;
	}

	public static isEdge():boolean {
		return Browser.getInfo().parentBrowser === Browser.Edge;
	}

	public static isChrome():boolean {
		return Browser.getInfo().parentBrowser === Browser.Chrome;
	}

	public static isFireFox():boolean {
		return Browser.getInfo().parentBrowser === Browser.Firefox;
	}

	public static isFacebook():boolean {
		return Browser.getInfo().browser === Browser.FacebookCanvasDesktop;
	}

	public static isOldOpera():boolean {
		return Browser.getInfo().parentBrowser === Browser.Opera; // у новой оперы parentBrowser == Chrome
	}

	public static isSafari():boolean {
		return Browser.getInfo().parentBrowser === Browser.Safari; 
	}

	public static isIos():boolean {
		return Browser.getInfo().osType === 'iPhone' || Browser.getInfo().osType === 'iPad' || Browser.getInfo().osType === 'iOs';
	}

	public static isAndroid():boolean {
		return Browser.getInfo().osType === 'Android';
	}
}